module.exports = __webpack_public_path__ + "static/img/WILLEM-DUURSMA.92b5adc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WILLEM-DUURSMA.jpg
// module id = gmx9
// module chunks = 0